import React, { useContext } from 'react';
import {
  useDataModel
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { SponsoredBanner } from '../components/SponsoredBanner';

const SponsoredBannerComposable = () => {
  const ctx = useContext(ExperienceContext);
  const { customContext } = ctx;
  const { isHybridLayout, isSearch, isBrowse } = customContext;
  const variables = customContext?.variables || {}; /// / Get global search variables from custom context
  const defaultOptions = {
    variables,
    ssr: true,
    skip: !variables.navParam && !variables.keyword,
  };
  const { data } = useDataModel('searchModel', defaultOptions) || {};
  const { metadata } = data?.searchModel || {};
  const { contentType } = metadata || {};
  const isCategory = contentType === 'categorypage';
  return (
    <div className={isHybridLayout && 'sui-ml-2'}>
      <SponsoredBanner
        browserId={ctx?.cookie?.adobeCookie?.MCMID || ''}
        pageContext={{
          label: 'browse-search',
          data,
          keyword: variables?.keyword || '',
          isCategory,
          isBrowse,
          isSearch
        }}
        avoidPreload={false}
      />
    </div>
  );
};

SponsoredBannerComposable.displayName = 'SponsoredBannerComposable';

SponsoredBannerComposable.dataModel = SponsoredBanner.dataModel;
export { SponsoredBannerComposable };
